// extracted by mini-css-extract-plugin
module.exports = {"container":"txID_container__21fkH","dark":"txID_dark__1JKoZ","txID":"txID_txID__1ZHmU","icon":"txID_icon__1ymTT"};